/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CRLValidationResult } from '../model';
// @ts-ignore
import type { CacheDetails } from '../model';
// @ts-ignore
import type { ObjectEncoding } from '../model';
// @ts-ignore
import type { X509CRLDetails } from '../model';
/**
 * CRLApi - axios parameter creator
 * @export
 */
export const CRLApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerDeleteCRL: async (thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('cRLControllerDeleteCRL', 'thumbprint', thumbprint)
            const localVarPath = `/api/crl/deleteCRL`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerDeleteCRLs: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('cRLControllerDeleteCRLs', 'requestBody', requestBody)
            const localVarPath = `/api/crl/deleteCRLs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ObjectEncoding} encoding 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerExportCRLs: async (encoding: ObjectEncoding, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encoding' is not null or undefined
            assertParamExists('cRLControllerExportCRLs', 'encoding', encoding)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('cRLControllerExportCRLs', 'requestBody', requestBody)
            const localVarPath = `/api/crl/exportCRLs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (encoding !== undefined) {
                localVarQueryParameter['encoding'] = encoding;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerGetCRL: async (thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('cRLControllerGetCRL', 'thumbprint', thumbprint)
            const localVarPath = `/api/crl/getCRL`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerGetCRLs: async (firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/crl/getCRLs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerGetCRLsCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/crl/getCRLsCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerGetCacheStatistics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/crl/getCacheStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [derEncodedCRLs] 
         * @param {boolean} [skipExpiredCRL] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerImportCRLs: async (derEncodedCRLs?: File, skipExpiredCRL?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/crl/importCRLs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


            if (derEncodedCRLs !== undefined) { 
                localVarFormParams.append('derEncodedCRLs', derEncodedCRLs as any);
            }
    
            if (skipExpiredCRL !== undefined) { 
                localVarFormParams.append('skipExpiredCRL', String(skipExpiredCRL) as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerInvalidateCaches: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/crl/invalidateCaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerRefreshCRLStore: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/crl/refreshCRLStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerValidateCRL: async (thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('cRLControllerValidateCRL', 'thumbprint', thumbprint)
            const localVarPath = `/api/crl/validateCRL`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CRLApi - functional programming interface
 * @export
 */
export const CRLApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CRLApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cRLControllerDeleteCRL(thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<X509CRLDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cRLControllerDeleteCRL(thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRLApi.cRLControllerDeleteCRL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cRLControllerDeleteCRLs(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cRLControllerDeleteCRLs(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRLApi.cRLControllerDeleteCRLs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ObjectEncoding} encoding 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cRLControllerExportCRLs(encoding: ObjectEncoding, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cRLControllerExportCRLs(encoding, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRLApi.cRLControllerExportCRLs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cRLControllerGetCRL(thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<X509CRLDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cRLControllerGetCRL(thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRLApi.cRLControllerGetCRL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cRLControllerGetCRLs(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CRLDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cRLControllerGetCRLs(firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRLApi.cRLControllerGetCRLs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cRLControllerGetCRLsCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cRLControllerGetCRLsCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRLApi.cRLControllerGetCRLsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cRLControllerGetCacheStatistics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CacheDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cRLControllerGetCacheStatistics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRLApi.cRLControllerGetCacheStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [derEncodedCRLs] 
         * @param {boolean} [skipExpiredCRL] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cRLControllerImportCRLs(derEncodedCRLs?: File, skipExpiredCRL?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CRLDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cRLControllerImportCRLs(derEncodedCRLs, skipExpiredCRL, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRLApi.cRLControllerImportCRLs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cRLControllerInvalidateCaches(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CacheDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cRLControllerInvalidateCaches(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRLApi.cRLControllerInvalidateCaches']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cRLControllerRefreshCRLStore(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cRLControllerRefreshCRLStore(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRLApi.cRLControllerRefreshCRLStore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cRLControllerValidateCRL(thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CRLValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cRLControllerValidateCRL(thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRLApi.cRLControllerValidateCRL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CRLApi - factory interface
 * @export
 */
export const CRLApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CRLApiFp(configuration)
    return {
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerDeleteCRL(thumbprint: string, options?: any): AxiosPromise<X509CRLDetails> {
            return localVarFp.cRLControllerDeleteCRL(thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerDeleteCRLs(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.cRLControllerDeleteCRLs(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ObjectEncoding} encoding 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerExportCRLs(encoding: ObjectEncoding, requestBody: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp.cRLControllerExportCRLs(encoding, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerGetCRL(thumbprint: string, options?: any): AxiosPromise<X509CRLDetails> {
            return localVarFp.cRLControllerGetCRL(thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerGetCRLs(firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<X509CRLDetails>> {
            return localVarFp.cRLControllerGetCRLs(firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerGetCRLsCount(options?: any): AxiosPromise<number> {
            return localVarFp.cRLControllerGetCRLsCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerGetCacheStatistics(options?: any): AxiosPromise<CacheDetails> {
            return localVarFp.cRLControllerGetCacheStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [derEncodedCRLs] 
         * @param {boolean} [skipExpiredCRL] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerImportCRLs(derEncodedCRLs?: File, skipExpiredCRL?: boolean, options?: any): AxiosPromise<Array<X509CRLDetails>> {
            return localVarFp.cRLControllerImportCRLs(derEncodedCRLs, skipExpiredCRL, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerInvalidateCaches(options?: any): AxiosPromise<CacheDetails> {
            return localVarFp.cRLControllerInvalidateCaches(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerRefreshCRLStore(options?: any): AxiosPromise<void> {
            return localVarFp.cRLControllerRefreshCRLStore(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cRLControllerValidateCRL(thumbprint: string, options?: any): AxiosPromise<CRLValidationResult> {
            return localVarFp.cRLControllerValidateCRL(thumbprint, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CRLApi - object-oriented interface
 * @export
 * @class CRLApi
 * @extends {BaseAPI}
 */
export class CRLApi extends BaseAPI {
    /**
     * 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRLApi
     */
    public cRLControllerDeleteCRL(thumbprint: string, options?: RawAxiosRequestConfig) {
        return CRLApiFp(this.configuration).cRLControllerDeleteCRL(thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRLApi
     */
    public cRLControllerDeleteCRLs(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CRLApiFp(this.configuration).cRLControllerDeleteCRLs(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ObjectEncoding} encoding 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRLApi
     */
    public cRLControllerExportCRLs(encoding: ObjectEncoding, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CRLApiFp(this.configuration).cRLControllerExportCRLs(encoding, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRLApi
     */
    public cRLControllerGetCRL(thumbprint: string, options?: RawAxiosRequestConfig) {
        return CRLApiFp(this.configuration).cRLControllerGetCRL(thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRLApi
     */
    public cRLControllerGetCRLs(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return CRLApiFp(this.configuration).cRLControllerGetCRLs(firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRLApi
     */
    public cRLControllerGetCRLsCount(options?: RawAxiosRequestConfig) {
        return CRLApiFp(this.configuration).cRLControllerGetCRLsCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRLApi
     */
    public cRLControllerGetCacheStatistics(options?: RawAxiosRequestConfig) {
        return CRLApiFp(this.configuration).cRLControllerGetCacheStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [derEncodedCRLs] 
     * @param {boolean} [skipExpiredCRL] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRLApi
     */
    public cRLControllerImportCRLs(derEncodedCRLs?: File, skipExpiredCRL?: boolean, options?: RawAxiosRequestConfig) {
        return CRLApiFp(this.configuration).cRLControllerImportCRLs(derEncodedCRLs, skipExpiredCRL, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRLApi
     */
    public cRLControllerInvalidateCaches(options?: RawAxiosRequestConfig) {
        return CRLApiFp(this.configuration).cRLControllerInvalidateCaches(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRLApi
     */
    public cRLControllerRefreshCRLStore(options?: RawAxiosRequestConfig) {
        return CRLApiFp(this.configuration).cRLControllerRefreshCRLStore(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRLApi
     */
    public cRLControllerValidateCRL(thumbprint: string, options?: RawAxiosRequestConfig) {
        return CRLApiFp(this.configuration).cRLControllerValidateCRL(thumbprint, options).then((request) => request(this.axios, this.basePath));
    }
}

